const EDITABLE_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

/** Whether typing at `target` already means something, so most bindings must not steal the key. */
export const isEditableTarget = (target: EventTarget | null): boolean => {
    if (!(target instanceof HTMLElement)) {
        return false;
    }
    return target.isContentEditable || EDITABLE_TAGS.has(target.tagName);
};
